var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"pips"},[_c('div',{staticClass:"pip"}),_vm._v(" "),_vm._l((_vm.routes),function(route){return _c('div',{key:route.path,staticClass:"pip",class:{ 'is-active' : _vm.isCurrent(route) }})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }